// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"997":"41d4f8c0","1054":"41d4f8c0","6751":"100065f3"}[chunkId] + ".chunk.css";
};